import Agilite from 'agilite'
import { firebaseAuth } from '../../..'
import { formatDateOfBirth, handleError } from '../../lib/utils'
import store from '../../../store'
import { getDataWithSync, updateItemWithSync } from '../../../db/dbSync'
import { STORES } from '../../../db/indexedDB'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

export const findAgiliteUser = (filter, isActiveOnly = false, projection) => {
  return new Promise((resolve, reject) => {
    let qry = { $or: [] }
    let response = null

    ;(async () => {
      try {
        for (const prop in filter) {
          qry.$or.push({ [prop]: filter[prop] })
        }

        if (isActiveOnly) {
          qry['extraData.isActive'] = isActiveOnly
        }

        response = await agilite.Connectors.execute('auth_users', 'find', { filter: JSON.stringify(qry), projection })

        if (response.data.length > 0) {
          resolve(response.data[0])
        } else {
          resolve(null)
        }
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const createAgiliteUser = (data, useFirebaseId = true, createdBy) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      const State = store.getState()
      let response = null
      let timestamp = Date()
      let usersCount = 0

      try {
        data.extraData = { ...data.extraData }

        if (State.auth?.agiliteUser?.extraData?.role?.type !== 'super_admin') {
          data.extraData.entities = [State.core.entity._id]
        }

        data.dateCreated = timestamp
        data.dateModified = timestamp

        // Formatting
        if (data.dateOfBirth) {
          data.dateOfBirth = formatDateOfBirth(data.dateOfBirth)
        }

        usersCount = await agilite.Connectors.execute('auth_users', 'count')

        response = await agilite.Connectors.execute('auth_users', 'create', {
          data: JSON.stringify({
            ...data,
            billingId: usersCount.data.result + 1,
            firebaseId: useFirebaseId ? firebaseAuth.currentUser.uid : '',
            createdBy: createdBy ? createdBy : 'System'
          })
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const updateAgiliteUser = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      let response = null
      let timestamp = Date()

      try {
        data.dateModified = timestamp

        // Formatting
        if (data.dateOfBirth) {
          data.dateOfBirth = formatDateOfBirth(data.dateOfBirth)
        }

        response = await updateItemWithSync(STORES.AUTH_USERS, {
          body: {
            recordId,
            data: JSON.stringify(data)
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': 'auth_users',
              'route-key': 'update'
            }
          }
        })

        resolve(response)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const getCountries = (filter) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await getDataWithSync(STORES.COUNTRIES, {
          body: {
            filter: JSON.stringify(filter)
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': 'countries',
              'route-key': 'find'
            }
          }
        })
        resolve(response)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}
